export const CITY = "CITY";
export const ALL_CITY = "ALL_CITY";
export const ZONE = "ZONE";
export const AREA = "AREA";
export const STATE = "STATE";
export const LOCATION_TYPE = "LOCATION_TYPE";
export const PIN_CODE = "PIN_CODE";
export const SHIP_PIN_CODE = "SHIP_PIN_CODE";
export const STATE_REGION = "STATE_REGION";

